import { render } from "./YourDetailsIP1.vue?vue&type=template&id=36ea91ec&scoped=true"
import script from "./YourDetailsIP1.vue?vue&type=script&lang=js"
export * from "./YourDetailsIP1.vue?vue&type=script&lang=js"

import "./YourDetailsIP1.vue?vue&type=style&index=0&id=36ea91ec&lang=scss"
import "./YourDetailsIP1.vue?vue&type=style&index=1&id=36ea91ec&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ea91ec"]])

export default __exports__